import React from "react";
import Button from "@sendsprint/ui-react/components/button";
import ErrorLayout from "@/layouts/error";
import ErrorCard from "@/layouts/error/components/errorCard";
import ErrorUnplugged from "@/assets/svgs/error-unplugged.svg";

type ErrorProps = {
  resetError: () => void;
};

const ErrorScreen = () => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <ErrorLayout pageTitle="An error occurred">
      <ErrorCard
        imageContent={
          <div className="ss:p-8 ss:bg-neutral-20">
            <ErrorUnplugged className="ss:h-44 ss:w-44 ss:inline-block" />
          </div>
        }
        title="Something went wrong"
        content="An error has occurred. We are trying to fix this, please try again."
        footer={
          <Button
            onClick={refreshPage}
            variant="primary"
            fullWidth
            label="Try again"
          />
        }
      />
    </ErrorLayout>
  );
};

export type { ErrorProps };
export default ErrorScreen;
